import { FccManualPoolingOffReason } from '@backoffice-frontend/graphql'
import type { TFunction } from 'i18next'

export const getManualPoolingOffReasonTranslation = (
  t: TFunction,
  key: FccManualPoolingOffReason,
): string | undefined => {
  const map: Partial<Record<FccManualPoolingOffReason, string>> = {
    [FccManualPoolingOffReason.AdTestDrive]: t(
      'adFleetMap_option_poolingOffReasonTesting_label',
    ),
    [FccManualPoolingOffReason.Other]: t('common_other_label'),
    [FccManualPoolingOffReason.ShortBreak]: t('common_break_label'),
    [FccManualPoolingOffReason.Troubleshooting]: t(
      'adFleetMap_option_poolingOffReasonTroubleshooting_label',
    ),
  }
  return map[key] ?? key
}
